import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../../styles/lib/utils';
import { GridContext } from '../Grid';

const gridCellLinkVariants = cva(
  'font-medium text-xs text-grey-90 underline decoration-solid decoration-1 underline-offset-2 overflow-hidden text-ellipsis rounded-[2px] focus-ring',
  {
    variants: {
      variant: {
        default: 'font-noto',
        numeric: 'font-noto-mono',
      },
      lineClamp: {
        1: 'line-clamp-1',
        2: 'line-clamp-2',
        3: 'line-clamp-3',
      },
    },
    defaultVariants: {
      variant: 'default',
      lineClamp: 1,
    },
  },
);

function GridCellLink({
  className,
  variant,
  href = '',
  asChild = false,
  ...props
}: React.ComponentProps<'a'> & VariantProps<typeof gridCellLinkVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : 'a';

  const gridContext = React.useContext(GridContext);
  const effectiveSpacing = gridContext.spacing || 'cozy';

  const lineClamp = effectiveSpacing === 'comfy' ? 2 : effectiveSpacing === 'roomy' ? 3 : 1;

  return (
    <Comp
      data-slot="grid-cell-link"
      href={href}
      className={cn(gridCellLinkVariants({ variant, lineClamp, className }))}
      {...props}
    />
  );
}

export { GridCellLink };
